import { useMemo } from 'react'

import { LOCALE } from '@hhgtech/hhg-components/types'
import { useRouter } from 'next/router'

import { ExtendedNextRouter } from 'interfaces/types'

export function useRouterExtend(): ExtendedNextRouter & {
  router: ExtendedNextRouter
} {
  const router = useRouter()
  const res = useMemo(() => {
    const newRouter = {
      ...router,
      locale: (router.locale as LOCALE) || LOCALE.PhilippinesEnglish,
    }
    return {
      ...newRouter,
      router: newRouter,
    }
  }, [router])
  return res
}
